import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import ThemeConfig from 'webapp/const/theme-config';
import type { BlockVisualization, Theme } from 'webapp/enums/enums';

import FormSelectComponent from 'webapp/components/form/select';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
	onChange: (vis: BlockVisualization) => boolean; // returns true if confirm is shown and we must prevent change in the dropdown
	isReports?: boolean;
	theme?: Theme;
	extraClass?: string;
}

export default class BlockSettingsVisualizationsDropdownComponent extends Component<Args> {
	@service('model-manager/blocks') declare mmBlocksService: Service.ModelManager.Blocks;

	get options() {
		const firstThemeColors = ThemeConfig[0]!.colors;

		const baseList = this.args.blockM.switchableVisualizationList;

		return baseList.map((item, i) => {
			return {
				value: item.id,
				label: item.labelLong || item.label,
				iconName: this.mmBlocksService.getVisualizationTypeIcon(item.id),
				iconFill: firstThemeColors[i],
			};
		});
	}

	@action
	onChange() {
		// nothing - onBeforeChange takes care of stuff
	}

	@action
	onBeforeChange(
		_currentValue: BlockVisualization,
		newValue: BlockVisualization,
		selectEl: JQuery<HTMLElement>,
	) {
		const prevent = this.args.onChange(newValue);
		try {
			selectEl?.select2('close');
		} catch (_e) {
			// do nothing
		}
		return prevent;
	}
	<template>
		<FormSelectComponent
			name="visualization"
			@selected={{@blockM.visualization}}
			@options={{this.options}}
			@onChange={{this.onChange}}
			@beforeChange={{this.onBeforeChange}}
			@isRequired={{true}}
			@extraClass="svg-as-avatar {{@extraClass}}"
			@theme={{@theme}}
		/>
	</template>
}
